export const pt = {
  nav: {
    home: "Início",
    product: "Soluções",
    howItWorks: "Como Funciona",
    pricing: "Modelos",
    services: "Serviços",
    benchmarks: "Benchmarks",
    about: "Sobre",
    contact: "Contato",
    blog: "Blog",
    help: "Ajuda",
    status: "Status",
    content: "Conteúdo",
    more: "Mais",
  },

  common: {
    learnMore: "Saiba mais",
    getStarted: "Começar",
    contactUs: "Fale conosco",
    talkOnWhatsApp: "Falar no WhatsApp",
    sendMessage: "Enviar mensagem",
    loading: "Carregando...",
    error: "Erro",
    success: "Sucesso",
    required: "Obrigatório",
    optional: "Opcional",
    yes: "Sim",
    no: "Não",
    notSure: "Não tenho certeza",
    other: "Outro",
    readMore: "Ler mais",
    backToBlog: "Voltar ao blog",
    publishedOn: "Publicado em",
  },

  footer: {
    tagline: "Automation that moves revenue.",
    rights: "Todos os direitos reservados.",
    terms: "Termos de Uso",
    privacy: "Política de Privacidade",
    commercial: "Termos Comerciais",
    product: "Soluções",
    company: "Empresa",
    legal: "Legal",
    platforms: "Plataformas",
  },

  home: {
    heroTitle: "Ajudamos sua operação a começar e crescer.",
    heroTitleHighlight: "",
    heroSubtitle: "Loja, automações, IA, integrações e dashboards para quem está construindo ou organizando a operação online.",
    heroCta: "Falar com a ProcessSurge",
    heroSecondary: "Ver como funciona",

    featuresTitle: "Por que a ProcessSurge?",
    featuresSubtitle: "Estrutura, automação e clareza para quem vende online e quer evoluir com consistência.",

    feature1Title: "Parceiro técnico",
    feature1Desc: "Entramos para apoiar o começo da operação e continuar ajudando conforme ela cresce.",

    feature2Title: "Soluções conectadas",
    feature2Desc: "Loja, recuperação de receita, IA, integrações e dados trabalhando de forma complementar.",

    feature3Title: "Sem complicação desnecessária",
    feature3Desc: "Indicamos e integramos as ferramentas certas para o seu momento, sem forçar trocas desnecessárias.",

    feature4Title: "Clareza no que entregamos",
    feature4Desc: "Escopo, operação e resultados explicados de forma simples e objetiva.",

    servicesTitle: "Do começo da loja à operação mais madura",
    servicesSubtitle: "Ajudamos você a organizar o presente e preparar o próximo passo.",

    ctaTitle: "Vamos entender o que faz sentido para o seu momento?",
    ctaSubtitle: "O diagnóstico é simples, consultivo e sem compromisso.",
    ctaCta: "Falar com a equipe",
  },

  product: {
    heroTitle: "O Ecossistema ProcessSurge",
    heroSubtitle: "Cinco pilares para eliminar os gargalos do seu marketplace — do primeiro clique ao relatório que mostra o quanto você cresceu.",

    p1Tag: "Pilar 01 — Presença",
    p1Title: "Fazemos sua loja.",
    p1Subtitle: "Loja pronta para vender",
    p1Desc: "Como Parceiro Nuvemshop, criamos sua loja do zero: tema, catálogo, meios de pagamento, frete e SEO básico. Você não precisa entender de tecnologia para ter uma loja profissional funcionando.",
    p1F1: "Criação da loja na Nuvemshop (plano gratuito disponível)",
    p1F2: "Configuração de tema profissional e identidade visual",
    p1F3: "Integração de meios de pagamento e frete",
    p1F4: "SEO básico e domínio configurado",
    p1F5: "Treinamento para você gerir sua loja com autonomia",
    p1Note: "Ideal para quem ainda não tem loja ou quer migrar de uma plataforma que não entrega resultado.",

    p2Tag: "Pilar 02 — Receita",
    p2Title: "Recuperamos o dinheiro que você já ganhou.",
    p2Subtitle: "Cart Recovery + Reengajamento",
    p2Desc: "Nosso sistema identifica carrinhos abandonados e dispara comunicações automáticas no momento certo. Além disso, reengajamos clientes inativos com ofertas personalizadas. Modelo Success Fee: você paga uma comissão só sobre o que recuperamos.",
    p2F1: "Recuperação automática de carrinhos abandonados",
    p2F2: "Reengajamento de base de clientes inativos",
    p2F3: "Mensagens personalizadas por WhatsApp e e-mail",
    p2F4: "Relatório mensal de receita recuperada",
    p2F5: "Modelo Success Fee — risco zero para você",
    p2Note: "Em média, lojas recuperam entre 5% e 15% das vendas perdidas com abandono de carrinho. Isso é receita que já era sua.",

    p3Tag: "Pilar 03 — Atendimento",
    p3Title: "IA que atende seus clientes.",
    p3Subtitle: "Surge Assist",
    p3Desc: "O Surge Assist é nossa IA de atendimento treinada com as informações do seu negócio. Integramos à plataforma que você já usa — ou montamos a estrutura completa com ChatWoot e EvolutionAPI.",
    p3F1: "IA treinada com produtos, preços e políticas da sua loja",
    p3F2: "Integração com WhatsApp, Instagram e outros canais",
    p3F3: "Atendimento 24/7 sem custo adicional por volume",
    p3F4: "Integração com sua plataforma de atendimento atual",
    p3F5: "Ou estrutura completa: ChatWoot + EvolutionAPI",
    p3Note: "Não concorremos com Zendesk, Zenvia ou Hi Platform — integramos com eles quando faz sentido. Você não precisa trocar o que funciona.",

    p4Tag: "Pilar 04 — Processos",
    p4Title: "Automatizamos o que te trava todo dia.",
    p4Subtitle: "Integrações Personalizadas",
    p4Desc: "Aqui a ProcessSurge passa a fazer parte das veias da sua empresa. Eliminamos processos manuais e conectamos suas ferramentas: loja, CRM, ERP, planilhas e sistemas logísticos.",
    p4F1: "Mapeamento e automação de processos manuais críticos",
    p4F2: "Integração entre plataformas de e-commerce, CRM e ERP",
    p4F3: "Sincronização de estoque, pedidos e clientes",
    p4F4: "Alertas e notificações automáticas para sua equipe",
    p4F5: "Robôs de backoffice para tarefas repetitivas",
    p4Note: "Cada hora que sua equipe gasta copiando dados entre sistemas é dinheiro jogado fora. Isso acaba aqui.",

    p5Tag: "Pilar 05 — Clareza",
    p5Title: "Mostramos o quanto você cresceu.",
    p5Subtitle: "Dashboards & Relatórios",
    p5Desc: "Com toda a estrutura funcionando, entregamos dashboards e relatórios que colocam os números na sua frente. Você vê em tempo real quanto vendeu, quanto recuperamos e o impacto real da ProcessSurge.",
    p5F1: "Dashboard unificado de vendas, atendimento e automações",
    p5F2: "Relatórios mensais de receita recuperada e economizada",
    p5F3: "Insights e alertas baseados nos seus dados",
    p5F4: "Visão clara do ROI de cada pilar contratado",
    p5F5: "Reuniões de análise estratégica periódicas",
    p5Note: "Nosso trabalho só tem valor se você enxergar. Por isso cada relatório mostra exatamente o que a ProcessSurge fez pelo seu caixa.",

    ctaTitle: "Quer entender como funciona na prática?",
    ctaCta: "Falar com a equipe",
  },

  howItWorks: {
    heroTitle: "Como funciona",
    heroSubtitle: "Simples de começar. Difícil de parar de crescer.",
    heroDesc: "Você não precisa contratar tudo de uma vez. Começa pelo que precisa agora — e expande conforme cresce.",

    step1Title: "Diagnóstico gratuito",
    step1Desc: "Mapeamos sua situação atual, seus gargalos e o que faz mais sentido implantar primeiro. Sem compromisso.",

    step2Title: "Proposta personalizada",
    step2Desc: "Montamos um plano sob medida com os pilares certos para o seu momento e orçamento.",

    step3Title: "Implantação rápida",
    step3Desc: "Implementamos, testamos e entregamos. Você acompanha tudo com relatórios claros desde o primeiro dia.",

    step4Title: "Crescimento contínuo",
    step4Desc: "A ProcessSurge fica com você. Cada novo pilar implantado aprofunda os resultados do anterior.",

    timelineNote: "A maioria dos clientes tem o primeiro pilar ativo em menos de 2 semanas.",

    diffTitle: "O que nos diferencia",
    diff1Title: "Parceiro, não fornecedor",
    diff1Desc: "Não entregamos software e sumimos. Ficamos do seu lado, ajustando e evoluindo conforme seu negócio cresce.",
    diff2Title: "Foco em quem está começando",
    diff2Desc: "Enquanto os grandes players focam nas baleias do mercado, a ProcessSurge é especialista em quem está construindo o marketplace do zero.",
    diff3Title: "Transparência em tudo",
    diff3Desc: "Dashboards auditáveis, relatórios mensais e reuniões periódicas. Você sempre sabe o que está pagando e o que está recebendo.",
    diff4Title: "Integração sem troca",
    diff4Desc: "Trabalhamos com as ferramentas que você já usa. Não pedimos que você jogue fora o que funciona — conectamos tudo.",
  },

  pricing: {
    heroTitle: "Modelos que fazem sentido para quem está crescendo",
    heroSubtitle: "Cada pilar tem um modelo comercial pensado para o momento do empreendedor. Sem surpresas, sem risco desnecessário.",

    model1Title: "Criação de Loja",
    model1Type: "Projeto Fechado",
    model1Desc: "Escopo e valor definidos antes de começar. Você sabe exatamente o que vai receber e quanto vai pagar.",
    model1Tag: "Sem mensalidade inicial",

    model2Title: "Cart Recovery + Reengajamento",
    model2Type: "Success Fee",
    model2Desc: "Implantamos, cuidamos e recebemos apenas uma comissão sobre o que recuperamos. Risco zero para você.",
    model2Tag: "Só paga se vender",

    model3Title: "Surge Assist (IA)",
    model3Type: "Mensalidade por Escopo",
    model3Desc: "Mensalidade fixa com escopo definido. Sem cobrança por volume de tickets.",
    model3Tag: "Previsível",

    model4Title: "Integrações & Automações",
    model4Type: "Projeto + Manutenção",
    model4Desc: "Setup com escopo fechado + mensalidade opcional de monitoramento. Você escolhe o que faz sentido.",
    model4Tag: "Flexível",

    model5Title: "Dashboards & Relatórios",
    model5Type: "Incluído nos pilares",
    model5Desc: "Os relatórios fazem parte da entrega. Transparência não é extra — é o padrão.",
    model5Tag: "Incluído",

    whatIsRecoveredTitle: "O que conta como 'recuperado'",
    whatIsRecoveredDesc: "Um carrinho é considerado recuperado quando:",
    recovered1: "O cliente recebeu nossa comunicação",
    recovered2: "Finalizou a compra dentro da janela de atribuição acordada",
    recovered3: "O pedido não foi cancelado ou estornado",

    whatIsNotChargedTitle: "O que NÃO cobramos",
    notCharged1: "Setup inicial ou implementação do Cart Recovery",
    notCharged2: "Mensalidades fixas para o modelo Success Fee",
    notCharged3: "Compras que teriam acontecido de qualquer forma",
    notCharged4: "Pedidos fora da janela de atribuição",

    auditTitle: "Auditoria e transparência",
    auditDesc: "Fornecemos relatórios detalhados para conferência. A definição de 'recuperado' é acordada antes do início e documentada em contrato.",

    ctaTitle: "Quer uma proposta personalizada?",
    ctaCta: "Solicitar proposta",
  },

  services: {
    heroTitle: "Serviços do Ecossistema",
    heroSubtitle: "Cada pilar é um serviço especializado. Você escolhe por onde começar — e cresce no seu ritmo.",

    integrationsTitle: "Integrações de Sistemas",
    integrationsDesc: "Conectamos suas ferramentas e plataformas. Loja, CRM, ERP, logística — tudo conversando entre si sem trabalho manual.",
    integrationsFor: "Para: operações que perdem tempo copiando dados entre sistemas.",

    automationTitle: "Automação de Processos",
    automationDesc: "Automatizamos tarefas repetitivas que consomem o tempo da sua equipe: aprovações, notificações, relatórios periódicos e muito mais.",
    automationFor: "Para: equipes sobrecarregadas com trabalho operacional repetitivo.",

    rpaTitle: "RPA (Robotic Process Automation)",
    rpaDesc: "Robôs de software que executam tarefas em sistemas diversos, mesmo sem APIs. Ideal para sistemas legados.",
    rpaFor: "Para: processos em sistemas antigos ou sem possibilidade de integração direta.",

    dataTitle: "Dashboards & Business Intelligence",
    dataDesc: "Transformamos dados espalhados em dashboards e relatórios estratégicos para tomada de decisão em tempo real.",
    dataFor: "Para: gestores que precisam de métricas confiáveis para crescer com segurança.",

    aiTitle: "Agentes de IA (Surge Assist)",
    aiDesc: "IA treinada no seu negócio para atender clientes 24/7. Integramos com sua plataforma atual ou montamos a estrutura do zero.",
    aiFor: "Para: quem quer escalar atendimento sem perder qualidade.",
    aiNote: "Não concorremos com Zendesk, Zenvia ou Hi Platform. Integramos com eles — você não precisa trocar o que funciona.",

    storeTitle: "Criação de Loja (Nuvemshop)",
    storeDesc: "Somos Parceiro Nuvemshop. Criamos sua loja do zero: tema, catálogo, pagamentos e SEO básico.",
    storeFor: "Para: quem ainda não tem presença online ou quer migrar de plataforma.",

    ctaTitle: "Quer um diagnóstico do seu negócio?",
    ctaCta: "Solicitar diagnóstico gratuito",
  },

  benchmarks: {
    heroTitle: "Benchmarks e Estudos",
    heroSubtitle: "Dados de mercado verificados para contextualizar o problema de abandono de carrinho.",
    disclaimerTitle: "Importante",
    disclaimerText: "Os benchmarks apresentados são referências de mercado, não resultados garantidos. Performance real varia conforme nicho, ticket médio, qualidade da base e execução.",
    baymardTitle: "Taxa de Abandono de Carrinho",
    baymardStat: "70,22%",
    baymardDesc: "Taxa média documentada de abandono de carrinho em compras online, segundo compilação de 49 estudos.",
    baymardSource: "Fonte: Baymard Institute",
    baymardLink: "https://baymard.com/lists/cart-abandonment-rate",
    klaviyoTitle: "Recuperação via Email",
    klaviyoStat: "3,33%",
    klaviyoStatTop: "7,69%",
    klaviyoDesc: "Taxa média de conversão em fluxos de carrinho abandonado. Top 10% alcançam taxa superior.",
    klaviyoContext: "Baseado em análise de 143.000 fluxos de carrinho abandonado em 2023.",
    klaviyoSource: "Fonte: Klaviyo",
    klaviyoLink: "https://www.klaviyo.com/blog/abandoned-cart-benchmarks",
    shopifyTitle: "Boas Práticas",
    shopifyDesc: "Referência educacional sobre exemplos e estratégias de email de carrinho abandonado.",
    shopifySource: "Fonte: Shopify Blog",
    shopifyLink: "https://www.shopify.com/blog/abandoned-cart-emails",
    contextTitle: "Contexto importante",
    contextText: "Esses números servem como referência de mercado. Resultados reais dependem de múltiplos fatores incluindo nicho, ticket médio, timing das mensagens, qualidade da base de contatos e relevância do conteúdo.",
  },

  about: {
    heroTitle: "Sobre a ProcessSurge",
    heroSubtitle: "Nascemos para ser o parceiro que o empreendedor precisa no começo do marketplace.",
    storyTitle: "Nossa história",
    storyText1: "A ProcessSurge nasceu da observação de um problema real: empreendedores com ótimos produtos, mas sem a estrutura tecnológica para vender bem online. As grandes plataformas focam nas baleias — mas quem está começando precisa de um parceiro, não de um software.",
    storyText2: "Decidimos construir um ecossistema que começa onde o empreendedor está, e cresce junto com ele. Do primeiro pedido ao dashboard que mostra o quanto evoluiu.",
    missionTitle: "Nossa missão",
    missionText: "Ser o ecossistema que coloca o marketplace do empreendedor no ar — e o faz crescer com inteligência, automação e clareza nos números.",
    approachTitle: "Nossa abordagem",
    approach1Title: "Parceiro, não fornecedor",
    approach1Desc: "Não entregamos software e sumimos. Acompanhamos a jornada e evoluímos junto com cada cliente.",
    approach2Title: "Foco em resultado mensurável",
    approach2Desc: "Se não gera resultado que você consegue ver e auditar, não faz sentido implementar.",
    approach3Title: "Respeito ao cliente final",
    approach3Desc: "Automação que protege a marca, não que queima a base de contatos.",
    approach4Title: "Integração sem troca",
    approach4Desc: "Trabalhamos com o que você já usa. Quando um grande player é a melhor opção, indicamos — e integramos.",
    valuesTitle: "Valores",
    value1: "Honestidade sobre capacidades e limitações",
    value2: "Documentação clara e acessível",
    value3: "Suporte próximo e responsivo",
    value4: "Melhoria contínua baseada em dados",
    value5: "O crescimento do cliente é o nosso crescimento",
  },

  contact: {
    heroTitle: "Vamos conversar",
    heroSubtitle: "Conte um pouco sobre o que você precisa e nossa equipe entra em contato.",
    formTitle: "Fale com a ProcessSurge",
    nameLabel: "Nome completo",
    namePlaceholder: "Seu nome",
    emailLabel: "Email",
    emailPlaceholder: "seu@email.com",
    whatsappLabel: "WhatsApp",
    whatsappPlaceholder: "+55 11 99999-9999",
    companyLabel: "Empresa",
    companyPlaceholder: "Nome da empresa",
    ecommerceUrlLabel: "Link do site, loja ou perfil",
    ecommerceUrlPlaceholder: "ex: https://sualoja.com.br",
    serviceLabel: "Principal interesse",
    servicePlaceholder: "Selecione",
    serviceStoreSetup: "Estruturar ou lançar a operação",
    serviceCartRecovery: "Recuperação de carrinhos",
    serviceAiSupport: "IA e atendimento",
    serviceIntegrations: "Integrações e automações",
    serviceData: "Dados e dashboards",
    serviceNotSure: "Quero ajuda para identificar",
    stageLabel: "Momento da operação",
    stagePlaceholder: "Selecione",
    stageStarting: "Estou começando agora",
    stageSelling: "Já vendo e quero organizar melhor",
    stageScaling: "Já tenho operação e quero escalar",
    stageDiagnosis: "Quero entender o melhor caminho",
    roleLabel: "Cargo",
    rolePlaceholder: "Seu cargo (opcional)",
    platformLabel: "Plataforma",
    platformPlaceholder: "Selecione",
    platformVtex: "VTEX",
    platformShopify: "Shopify",
    platformNuvemshop: "Nuvemshop",
    platformYampi: "Yampi",
    platformWooCommerce: "WooCommerce",
    platformCartpanda: "Cartpanda",
    platformTray: "Tray",
    platformLoja_Integrada: "Loja Integrada",
    platformAppmax: "Appmax",
    platformBoth: "Ambas",
    platformNotSure: "Não tenho certeza",
    platformNone: "Ainda não tenho loja",
    volumeLabel: "Volume mensal de pedidos",
    volumePlaceholder: "Selecione",
    volume1: "Até 500 pedidos/mês",
    volume2: "500 a 2.000 pedidos/mês",
    volume3: "2.000 a 10.000 pedidos/mês",
    volume4: "Mais de 10.000 pedidos/mês",
    aovLabel: "Ticket médio",
    aovPlaceholder: "Selecione",
    aov1: "Até R$ 100",
    aov2: "R$ 100 a R$ 300",
    aov3: "R$ 300 a R$ 1.000",
    aov4: "Mais de R$ 1.000",
    channelLabel: "Canal preferido de contato",
    channelPlaceholder: "Selecione",
    channelWhatsApp: "WhatsApp",
    channelEmail: "Email",
    channelSms: "SMS",
    channelOther: "Outro",
    couponLabel: "Usa cupons de desconto?",
    couponYes: "Sim",
    couponNo: "Não",
    couponNotSure: "Não tenho certeza",
    notesLabel: "Observações",
    notesPlaceholder: "Conte mais sobre a sua operação ou o que está precisando...",
    consentLabel: "Autorizo o contato para fins comerciais conforme LGPD.",
    submitButton: "Enviar mensagem",
    submitting: "Enviando...",
    successTitle: "Mensagem enviada!",
    successMessage: "Recebemos seu contato e retornaremos em breve.",
    errorTitle: "Erro ao enviar",
    errorMessage: "Ocorreu um erro. Por favor, tente novamente ou fale conosco via WhatsApp.",
    directContactTitle: "Contato direto",
    directContactEmail: "Email",
    directContactWhatsApp: "WhatsApp",
  },

  simulator: {
    title: "Simular impacto potencial",
    subtitle: "Estimativa baseada em dados informados. Resultados reais variam.",
    ordersLabel: "Pedidos por mês",
    ordersPlaceholder: "Ex: 1000",
    aovLabel: "Ticket médio (R$)",
    aovPlaceholder: "Ex: 250",
    abandonmentLabel: "Taxa de abandono estimada (%)",
    abandonmentPlaceholder: "Ex: 70",
    recoveryLabel: "Taxa de recuperação estimada (%)",
    recoveryPlaceholder: "Ex: 3",
    calculateButton: "Calcular",
    resultTitle: "Receita potencial recuperável",
    resultRange: "de {min} a {max}",
    resultMonthly: "por mês",
    disclaimerTitle: "Importante",
    disclaimerText: "Esta é uma estimativa simplificada. Resultados reais dependem de nicho, qualidade da base, timing, conteúdo das mensagens e outros fatores. Não garantimos resultados.",
    assumptionsTitle: "Premissas do cálculo",
    assumption1: "Taxa de abandono aplicada sobre pedidos informados",
    assumption2: "Taxa de recuperação aplicada sobre carrinhos abandonados",
    assumption3: "Variação de ±30% no resultado para formar o range",
  },

  supportSimulator: {
    title: "Simule economia de atendimento",
    subtitle: "Compare o custo real por ticket entre humano e IA.",
    ticketsLabel: "Tickets / mês (Total)",
    agentsLabel: "Atendentes humanos",
    hourlyLabel: "Custo Hora (Salário + Encargos)",
    hourlyPlaceholder: "ex.: 18",
    hoursLabel: "Horas mensais por atendente",
    resolvedRateLabel: "Taxa de resolução da IA (%)",
    feePerResolvedLabel: "Custo Surge AI por resolução",
    calculate: "Calcular Economia",
    resultTitle: "Impacto financeiro estimado",
    ticketCostComparison: "Custo por Atendimento (Unitário)",
    humanCost: "Equipe Humana",
    aiCost: "Surge Assist",
    currentCostLabel: "Custo Operacional Atual",
    newCostLabel: "Custo com Híbrido (Humano + IA)",
    surgeFeesLabel: "Custo da Automação",
    resolvedTicketsLabel: "Tickets Automatizados",
    savingsLabel: "Economia Mensal Estimada",
    disclaimer: "Estimativa baseada no custo de oportunidade. A economia real reflete o tempo liberado da equipe para atividades de maior valor.",
  },

  blog: {
    heroTitle: "Blog",
    heroSubtitle: "Conteúdo sobre marketplace, automação, atendimento e crescimento para empreendedores.",
    nextTopicsTitle: "Próximos temas",
    nextTopics: [
      "Como montar sua primeira loja na Nuvemshop do zero",
      "Cart Recovery: o dinheiro que você deixa na mesa todo mês",
      "Surge Assist: como a IA pode atender seus clientes sem parecer robô",
      "5 processos manuais que você deveria automatizar hoje",
      "Dashboard de vendas: como ler os números que realmente importam",
      "LGPD e e-commerce: guia prático para conformidade",
    ],
    emptyState: "Ainda não publicamos posts. Volte em breve.",
    postNotFound: "Post não encontrado.",
  },

  legal: {
    termsTitle: "Termos de Uso",
    termsContent: `
## 1. Visão Geral
Bem-vindo à **ProcessSurge Tecnologia Ltda** ("ProcessSurge"), CNPJ **64.342.437/0001-96**, sediada na R. Pais Leme, 215, Conj 1713, Pinheiros, São Paulo - SP.

## 2. O Serviço
A ProcessSurge fornece software e consultoria para automação de processos, incluindo:
- **Criação de Loja:** Desenvolvimento de lojas na Nuvemshop como Parceiro Oficial.
- **Cart Recovery:** Recuperação ativa de checkouts abandonados e reengajamento de clientes inativos.
- **Surge Assist:** Agentes de IA para triagem e suporte ao cliente.
- **Integrações Personalizadas:** Conexão entre plataformas, CRM, ERP e outros sistemas.
- **Dashboards & Relatórios:** Inteligência de dados e relatórios estratégicos.

## 3. Uso Aceitável (Política Anti-Spam)
Temos tolerância zero com Spam. Ao utilizar nossas ferramentas de disparo, você concorda em contatar apenas leads com opt-in, respeitar stop rules imediatas e não utilizar bases compradas.

## 4. Limitação de Responsabilidade
A ProcessSurge não garante resultados financeiros específicos. Nossa responsabilidade limita-se ao valor pago pelos serviços no último mês.

## 5. Propriedade Intelectual
Os fluxos e dashboards desenvolvidos pela ProcessSurge permanecem propriedade intelectual da ProcessSurge. O Cliente recebe licença de uso enquanto durar o contrato.
    `,
    privacyTitle: "Política de Privacidade",
    privacyContent: `
## 1. Introdução
Esta Política descreve como a **ProcessSurge** coleta, usa e protege dados, em conformidade com a LGPD (Lei 13.709/2018).

## 2. Papéis na LGPD
- **Cliente (Você):** Controlador dos dados dos seus consumidores finais.
- **ProcessSurge (Nós):** Operador, processando dados estritamente para executar as automações contratadas.

## 3. Coleta de Dados
Coletamos apenas os dados necessários: Dados de Checkout, Histórico de Atendimento e Dados Cadastrais da Empresa.

## 4. Segurança
Utilizamos criptografia em repouso e em trânsito. Servidores com acesso restrito via VPN e autenticação forte.

## 5. Compartilhamento
Não vendemos dados. Compartilhamos apenas com provedores de infraestrutura e APIs de mensageria para execução do serviço.

## 6. Seus Direitos
Solicite exclusão de dados enviando e-mail para **contato@processsurge.com**.
    `,
    commercialTitle: "Termos Comerciais",
    commercialContent: `
## 1. Modelos Comerciais

### 1.1. Criação de Loja (Projeto Fechado)
Escopo e valor definidos previamente. Pagamento: 50% no aceite, 50% na entrega.

### 1.2. Cart Recovery & Reengajamento (Success Fee)
Comissão acordada em contrato (padrão: 10% a 20%) sobre pedidos recuperados dentro da janela de atribuição (24h a 72h).

### 1.3. Surge Assist (Mensalidade)
Mensalidade fixa por escopo de uso. Ajustes em aditivo contratual.

### 1.4. Integrações & Automações
Setup fee + mensalidade opcional de manutenção.

## 2. Custos de Terceiros
Custos de WhatsApp/Meta são pagos diretamente pelo Cliente ao Meta. A ProcessSurge não cobra markup.

## 3. Faturamento
Fechamento no último dia do mês. Vencimento dia 10 do mês seguinte. Inadimplência após 5 dias resulta em suspensão temporária.
    `,
  },

  whatsapp: {
    message: "Olá! Vim pelo site da ProcessSurge e gostaria de entender como vocês podem ajudar minha operação.",
  },

  meta: {
    homeTitle: "ProcessSurge | O Ecossistema do seu Marketplace",
    homeDesc: "Do zero à loja que realmente vende. A ProcessSurge é o parceiro para quem está começando no marketplace: loja, cart recovery, IA de atendimento, integrações e dashboards.",
    productTitle: "Ecossistema ProcessSurge | 5 Pilares para seu Marketplace",
    productDesc: "Cinco pilares para eliminar os gargalos do seu marketplace: loja, cart recovery, Surge Assist, integrações e dashboards.",
    howItWorksTitle: "Como Funciona | ProcessSurge",
    howItWorksDesc: "Simples de começar, difícil de parar de crescer.",
    pricingTitle: "Modelos Comerciais | ProcessSurge",
    pricingDesc: "Projeto fechado, success fee e mensalidade por escopo. Modelos justos para quem está crescendo.",
    servicesTitle: "Serviços | ProcessSurge",
    servicesDesc: "Loja, cart recovery, IA de atendimento, integrações e dashboards — o ecossistema completo.",
    benchmarksTitle: "Benchmarks e Estudos | ProcessSurge",
    benchmarksDesc: "Dados de mercado verificados sobre abandono e recuperação de carrinhos.",
    aboutTitle: "Sobre | ProcessSurge",
    aboutDesc: "Nascemos para ser o parceiro que o empreendedor precisa no começo do marketplace.",
    contactTitle: "Contato | ProcessSurge",
    contactDesc: "Diagnóstico gratuito e sem compromisso.",
    blogTitle: "Blog | ProcessSurge",
    blogDesc: "Conteúdo sobre marketplace, automação e crescimento para empreendedores.",
  },
};
